import { render, staticRenderFns } from "./TimeSlots.vue?vue&type=template&id=2124c2c4"
import script from "./TimeSlots.vue?vue&type=script&lang=js"
export * from "./TimeSlots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/atlassian/application-data/bamboo/local-working-dir/AG-FRTPRSTD0-JOBCOMPILAR/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2124c2c4')) {
      api.createRecord('2124c2c4', component.options)
    } else {
      api.reload('2124c2c4', component.options)
    }
    module.hot.accept("./TimeSlots.vue?vue&type=template&id=2124c2c4", function () {
      api.rerender('2124c2c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TimeSlots.vue"
export default component.exports